import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import * as React from 'react';
import { script } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import '../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../utils/style.js';
import { SLIDE_CHECK_APP_KEY } from '../../../api/captcha.js';
import 'qs';
import { isMobileSlideBar } from '../../../utils/index.js';
import { ECaptchaType } from '../../types.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SlideCheckBar = /*#__PURE__*/function (_React$Component) {
  _inherits(SlideCheckBar, _React$Component);

  var _super = _createSuper(SlideCheckBar);

  function SlideCheckBar() {
    var _context;

    var _this;

    _classCallCheck(this, SlideCheckBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));

    _defineProperty(_assertThisInitialized(_this), "nc", null);

    _defineProperty(_assertThisInitialized(_this), "isMobileSlideBar", isMobileSlideBar());

    _defineProperty(_assertThisInitialized(_this), "slideCheckOpts", {
      /* eslint-disable no-magic-numbers */
      renderTo: '#slide-check-container',
      appkey: SLIDE_CHECK_APP_KEY,
      scene: _this.props.scene || 'nc_other',
      token: [SLIDE_CHECK_APP_KEY, new Date().getTime(), Math.random()].join(':'),
      customWidth: _this.props.width || 300,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      is_Opt: 0,
      language: 'cn',
      isEnabled: true,
      timeout: 3000,
      times: 5,
      callback: function callback(data) {
        return _this.handleCheckSuccess(data);
      }
      /* eslint-enable no-magic-numbers */

    });

    _defineProperty(_assertThisInitialized(_this), "slideCheckOptsH5", {
      /* eslint-disable no-magic-numbers */
      renderTo: '#slide-check-container',
      appkey: SLIDE_CHECK_APP_KEY,
      scene: "".concat(_this.props.scene, "_h5"),
      token: [SLIDE_CHECK_APP_KEY, new Date().getTime(), Math.random()].join(':'),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      is_Opt: 0,
      language: 'cn',
      timeout: 10000,
      retryTimes: 5,
      errorTimes: 5,
      inline: true,
      bannerHidden: false,
      initHidden: false,
      callback: function callback(data) {
        return _this.handleCheckSuccess(data);
      }
      /* eslint-enable no-magic-numbers */

    });

    _defineProperty(_assertThisInitialized(_this), "slideHintText", {
      /* eslint-disable @typescript-eslint/naming-convention */
      _startTEXT: '请按住滑块，拖动到最右边',
      _yesTEXT: '验证成功',
      _error300: '出错了，点击 <a href="javascript:__nc.reset()">刷新</a> 重试',
      _errorNetwork: '网络不给力，请 <a href="javascript:__nc.reset()">点击刷新</a>'
      /* eslint-enable @typescript-eslint/naming-convention */

    });

    _defineProperty(_assertThisInitialized(_this), "slideHintTextH5", {
      LOADING: '加载中...',
      SLIDER_LABEL: '请按住滑块，拖动到最右边',
      CHECK_Y: '验证成功',
      ERROR_TITLE: '出错了，点击 <b onclick="javascript:window.resetNoCaptcha();">刷新</b>重试<br />',
      CHECK_N: '验证失败',
      OVERLAY_INFORM: '经检测你当前操作环境存在风险</br>请输入验证码',
      TIPS_TITLE: '验证码错误，请重新输入' // 验证码输错时的提示

    });

    _defineProperty(_assertThisInitialized(_this), "createNoCaptcha", function () {
      if (_this.nc && _this.nc.destroy) {
        _this.nc.destroy();
      }

      if (window.noCaptcha) {
        // eslint-disable-next-line new-cap
        _this.nc = new window.noCaptcha(_this.slideCheckOpts);

        _this.nc.upLang('cn', _this.slideHintText);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createH5NoCaptcha", function () {
      if (_this.nc && _this.nc.destroy) {
        _this.nc.destroy();
      }

      if (!window.NoCaptcha) return;
      _this.nc = window.NoCaptcha.init(_this.slideCheckOptsH5);
      window.NoCaptcha.setEnabled(true);

      _this.nc.reset(); // 请务必确保这里调用一次 reset() 方法


      window.NoCaptcha.upLang('cn', _this.slideHintTextH5);
      var stage1 = document.getElementsByClassName('stage1').item(0);
      var allowBtn = stage1 && stage1.getElementsByClassName('button').item(0);
      var successBg = stage1 && stage1.getElementsByClassName('bg-green').item(0);

      var updateAllowStyle = function updateAllowStyle() {
        if (allowBtn) {
          allowBtn.className = 'button success';
        }

        if (successBg) {
          successBg.className = 'bg-green success';
        }
      };

      _this.nc.on('success', updateAllowStyle);

      _this.nc.on('beforeverify', updateAllowStyle);

      window.resetNoCaptcha = function () {
        var _this$nc;

        return (_this$nc = _this.nc) === null || _this$nc === void 0 ? void 0 : _this$nc.reset();
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckSuccess", function (data) {
      var _context2, _context3;

      var session_id = data.csessionid;
      var sig = data.sig;
      var token = _this.isMobileSlideBar ? _this.slideCheckOptsH5.token : _this.slideCheckOpts.token;

      _this.props.callback({
        type: ECaptchaType.NoCaptcha,
        result: {
          session_id: session_id,
          sig: sig,
          token: token
        },
        captcha_token: _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(session_id, "|")).call(_context3, token, "|")).call(_context2, sig)
      });
    });

    return _this;
  }

  _createClass(SlideCheckBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var scriptUrl = '//g.alicdn.com/sd/ncpc/nc.js?t=2015052012';
      var initNoCaptcha = this.createNoCaptcha;

      if (this.isMobileSlideBar) {
        scriptUrl = '//g.alicdn.com/sd/nch5/index.js?t=2015052012';
        initNoCaptcha = this.createH5NoCaptcha;
      }

      script.loadScript('nc-nocaptcha-js', scriptUrl).then(function () {
        var _this2$props$onRef, _this2$props;

        initNoCaptcha();
        (_this2$props$onRef = (_this2$props = _this2.props).onRef) === null || _this2$props$onRef === void 0 ? void 0 : _this2$props$onRef.call(_this2$props, {
          reset: initNoCaptcha
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var darkMode = this.props.darkMode;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(prependPrefix('slide-check-bar'), {
          'slide-check-dark-bar': darkMode
        })
      }, /*#__PURE__*/React.createElement("div", {
        id: "slide-check-container",
        className: "nc-container"
      }));
    }
  }]);

  return SlideCheckBar;
}(React.Component);

export { SlideCheckBar };
